/* =========================================================
   J'ADORE — Menu (mega desktop + drawer mobile)
   ZABIEGI / BONY: kafle ze zdjeciem (categories[]).
   DERMOKOSMETYKI: rail obszarow (filtr) + siatka LOGOTYPOW marek (grafit
     w spoczynku, kolor po najechaniu; klik -> podstrona marki) + pasek zaufania.
   Dane: window.__JADORE_MENU (snippet jadore-megamenu-data).
   Nieinwazyjne: brak danych -> natywna nawigacja dziala normalnie.
   ========================================================= */
(function () {
  if (window.__JADORE_MENU_INIT__) return;
  window.__JADORE_MENU_INIT__ = true;

  /* Logotypy marek: 39/39 znormalizowanych (jednakowa masa optyczna, staly box 480x128).
     v2m = grafit (spoczynek, ladowany od razu), v2 = kolor (doladowywany przy najechaniu). */
  var LOGO_BASE = 'https://vqggtzmnlrcmjwgmlktr.supabase.co/storage/v1/object/public/vagheggi-images/jadore-derm/logos/';
  var LOGO_MONO = LOGO_BASE + 'v2m/';
  var LOGO_COLOR = LOGO_BASE + 'v2/';

  /* Kolor akcentowy marki (skladowe RGB) -> subtelny wash w tle kafla.
     Zrodlo: kolorowy logotyp, a gdy jest achromatyczny — srodek packshotu.
     '58,52,44' = cieply grafit dla marek bez koloru (Medik8, Dermalogica, Olaplex...). */
  var BRAND_TINT = {
    'authentic-beauty-concept':'114,164,182', 'cell-fusion-c':'185,175,111', 'dermalogica':'58,52,44',
    'dermaquest':'114,131,182', 'dermomedica-1':'180,139,53', 'diego-dalla-palma':'58,52,44',
    'dives-med':'58,52,44', 'dottore':'199,133,97', 'dsd-de-luxe':'174,140,79',
    'estgen':'194,172,102', 'esthederm':'58,52,44', 'image-skincare':'231,145,64',
    'intraceuticals':'33,161,226', 'is-clinical':'17,43,136', 'kevin-murphy':'58,52,44',
    'kv-1':'30,214,227', 'lpg':'198,180,98', 'maroccanoil':'17,136,134',
    'mediderma':'58,52,44', 'medik8':'58,52,44', 'mesoestetic':'182,144,114',
    'minetan':'212,131,84', 'my-skin-chemistry':'81,154,215', 'olaplex':'58,52,44',
    'onmacabim':'198,97,112', 'peel-mission':'178,22,33', 'phformula':'58,52,44',
    'podopharm':'216,80,104', 'pro-xn':'114,151,182', 'purles':'90,48,105',
    'retixc':'215,27,84', 'selvert-thermal':'58,52,44', 'sesderma':'52,75,101',
    'skeyndor':'58,52,44', 'solverx':'22,133,182', 'sunfx':'122,77,41',
    'teoxane':'58,52,44', 'vagheggi':'17,114,136', 'zo-skin-health':'58,52,44'
  };

  /* Marki, ktorych znak graficzny NIE zawiera nazwy (sam sygnet).
     Zamiast dokladac podpis pod logo — co rozpychalo rzad — pokazujemy wordmark. */
  var WORDMARK_ONLY = { 'my-skin-chemistry': 1 };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  ready(function () {
    var DATA = window.__JADORE_MENU;
    if (!DATA || !DATA.groups) return;
    var groups = {};
    DATA.groups.forEach(function (g) { groups[g.key] = g; });

    // ---- kafel (image card) dla zabiegi/bony ----
    function tile(item, cls) {
      var a = el('a', 'jad-tile' + (cls ? ' ' + cls : '') + (item.image ? '' : ' jad-tile--noimg'));
      a.href = item.url || '#';
      if (item.image) a.style.backgroundImage = "url('" + item.image + "')";
      a.appendChild(el('span', 'jad-tile__shade'));
      var cap = el('span', 'jad-tile__cap');
      cap.appendChild(el('b', 'jad-tile__title', String(item.title == null ? '' : item.title)));
      a.appendChild(cap);
      return a;
    }

    // ================= DESKTOP MEGA =================
    var panel = el('div', 'jad-mega');
    panel.setAttribute('role', 'region');
    var inner = el('div', 'jad-mega__inner');
    panel.appendChild(inner);
    document.body.appendChild(panel);
    var closeTimer = null;

    // ---- render: zabiegi / bony (kafle) ----
    function renderCategories(g) {
      panel.classList.remove('jad-mega--brands');
      inner.innerHTML = '';
      var head = el('div', 'jad-mega__head');
      var t = el('span', 'jad-mega__head-title', g.label);
      var all = el('a', 'jad-mega__head-all', 'Zobacz wszystko');
      all.href = g.url || '#';
      head.appendChild(t); head.appendChild(all);
      var grid = el('div', 'jad-mega__grid');
      (g.categories || []).slice(0, 16).forEach(function (c) { grid.appendChild(tile(c)); });
      inner.appendChild(head); inner.appendChild(grid);
    }

    // ---- render: dermokosmetyki (rail + marki + promo) ----
    function renderBrands(g) {
      panel.classList.add('jad-mega--brands');
      inner.innerHTML = '';
      var brands = g.brands || [];
      var areas = g.areas || [{ key: 'wszystkie', label: 'Wszystkie marki' }];
      var wrap = el('div', 'jad-derm');

      /* LEFT RAIL */
      var rail = el('div', 'jad-derm__rail');
      rail.appendChild(el('div', 'jad-derm__eyebrow', 'PIELĘGNACJA'));
      rail.appendChild(el('div', 'jad-derm__title', 'Dermokosmetyki'));
      rail.appendChild(el('div', 'jad-derm__rule'));
      /* okienko „Wszystkie kosmetyki" -> pełna strona sklepu dermokosmetyków */
      var allCosmo = el('a', 'jad-derm__allcosmo');
      allCosmo.href = g.allUrl || '/pages/dermokosmetyki';
      var acTxt = el('span', 'jad-derm__allcosmo-txt');
      acTxt.appendChild(el('b', null, 'Wszystkie kosmetyki'));
      acTxt.appendChild(el('span', 'jad-derm__allcosmo-sub', 'Cały sklep · filtruj i kupuj'));
      allCosmo.appendChild(acTxt);
      allCosmo.appendChild(el('span', 'jad-derm__allcosmo-arr', '→'));
      rail.appendChild(allCosmo);
      rail.appendChild(el('div', 'jad-derm__areas-label', 'OBSZARY PIELĘGNACJI'));
      var areasBox = el('div', 'jad-derm__areas');
      var mainHeadName; // set below
      var gridEl;       // set below
      function applyFilter(key, btn) {
        areasBox.querySelectorAll('.jad-derm__area').forEach(function (b) { b.classList.remove('is-active'); });
        if (btn) btn.classList.add('is-active');
        var shown = 0;
        gridEl.querySelectorAll('.jad-brand').forEach(function (card) {
          var a = card.getAttribute('data-areas') || '';
          var ok = key === 'wszystkie' || a.split(',').indexOf(key) !== -1;
          card.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        var lbl = (areas.filter(function (x) { return x.key === key; })[0] || {}).label || 'Wszystkie marki';
        mainHeadName.textContent = lbl + ' — ' + shown + (shown === 1 ? ' marka' : (shown < 5 ? ' marki' : ' marek'));
      }
      areas.forEach(function (ar, i) {
        var b = el('span', 'jad-derm__area' + (i === 0 ? ' is-active' : ''));
        b.appendChild(el('span', 'jad-derm__area-txt', ar.label));
        b.appendChild(el('span', 'jad-derm__area-arrow', '→'));
        b.addEventListener('mouseenter', function () { applyFilter(ar.key, b); });
        b.addEventListener('click', function () { applyFilter(ar.key, b); });
        areasBox.appendChild(b);
      });
      rail.appendChild(areasBox);
      var cnt = el('div', 'jad-derm__count');
      cnt.appendChild(el('span', 'jad-derm__count-num', String(brands.length)));
      cnt.appendChild(el('span', 'jad-derm__count-lbl', 'MAREK\nW OFERCIE'));
      rail.appendChild(cnt);
      var philo = el('a', 'jad-derm__philo', 'POZNAJ NASZĄ FILOZOFIĘ →');
      philo.href = g.brandsUrl || '/pages/marki';
      rail.appendChild(philo);

      /* CENTER — brand grid */
      var main = el('div', 'jad-derm__main');
      var mhead = el('div', 'jad-derm__mainhead');
      mhead.appendChild(el('span', 'jad-derm__mainhead-eyebrow', 'WYBIERZ MARKĘ'));
      mainHeadName = el('span', 'jad-derm__mainhead-active', 'Wszystkie marki — ' + brands.length + ' marek');
      mhead.appendChild(mainHeadName);
      gridEl = el('div', 'jad-derm__grid');
      brands.forEach(function (br) {
        var a = el('a', 'jad-brand');
        a.href = br.url || '#';
        a.setAttribute('data-areas', br.areas || '');
        a.setAttribute('aria-label', br.name || '');
        a.style.setProperty('--brand-rgb', BRAND_TINT[br.handle] || '58,52,44');

        var media = el('span', 'jad-brand__media');
        if (WORDMARK_ONLY[br.handle]) {
          media.classList.add('jad-brand__media--wm');
          media.appendChild(el('span', 'jad-brand__wm', br.name || ''));
          a.appendChild(media);
          a.addEventListener('mouseenter', function () { mainHeadName.textContent = br.name; });
          gridEl.appendChild(a);
          return;
        }
        var mono = el('img', 'jad-brand__logo jad-brand__logo--mono');
        mono.src = LOGO_MONO + br.handle + '.png';
        mono.alt = br.name || '';
        mono.loading = 'lazy';
        mono.width = 480; mono.height = 128;
        /* brak pliku logo -> elegancki wordmark zamiast pustego kafla */
        mono.addEventListener('error', function () {
          media.classList.add('jad-brand__media--wm');
          while (media.firstChild) media.removeChild(media.firstChild);
          media.appendChild(el('span', 'jad-brand__wm', br.name || ''));
        });
        var color = el('img', 'jad-brand__logo jad-brand__logo--color');
        color.alt = '';
        color.setAttribute('aria-hidden', 'true');
        color.setAttribute('data-src', LOGO_COLOR + br.handle + '.png');
        media.appendChild(mono);
        media.appendChild(color);

        a.appendChild(media);
        /* logotyp niesie juz nazwe marki — zadnego podpisu pod spodem */
        a.addEventListener('mouseenter', function () {
          mainHeadName.textContent = br.name;
          var src = color.getAttribute('data-src');
          if (src && !color.getAttribute('src')) color.setAttribute('src', src);
        });
        gridEl.appendChild(a);
      });
      main.appendChild(mhead); main.appendChild(gridEl);

      wrap.appendChild(rail); wrap.appendChild(main);
      panel.classList.remove('jad-mega--haspromo');
      inner.appendChild(wrap);

      /* value props strip */
      var props = el('div', 'jad-derm__props');
      ['100% oryginalnych kosmetyków', 'Możliwość konsultacji z kosmetologiem', 'Wyselekcjonowane marki'].forEach(function (txt) {
        var pr = el('span', 'jad-derm__prop');
        pr.appendChild(el('span', 'jad-derm__prop-ico', '✓'));
        pr.appendChild(el('span', null, txt));
        props.appendChild(pr);
      });
      inner.appendChild(props);
    }

    function renderPanel(key) {
      var g = groups[key];
      if (!g) return false;
      if (key === 'dermokosmetyki') {
        if (!(g.brands || []).length) return false;
        renderBrands(g);
        return true;
      }
      if (!(g.categories || []).length) return false;
      renderCategories(g);
      return true;
    }

    function positionPanel() {
      var h = document.querySelector('.header__wrapper, .shopify-section-header, .header, header');
      var top = 64;
      if (h) { var r = h.getBoundingClientRect(); top = Math.max(0, r.bottom); }
      panel.style.setProperty('--jad-mega-top', top + 'px');
    }
    function openPanel(key) {
      clearTimeout(closeTimer);
      if (!renderPanel(key)) { closePanel(); return; }
      positionPanel();
      panel.classList.add('is-open');
      document.documentElement.classList.add('jad-mega-on');
    }
    function closePanel() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        document.documentElement.classList.remove('jad-mega-on');
      }, 140);
    }
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { panel.classList.remove('is-open'); document.documentElement.classList.remove('jad-mega-on'); }
    });

    var keyByText = [
      { rx: /dermokosmetyk/i, key: 'dermokosmetyki' },
      { rx: /\bbony\b|prezentow/i, key: 'bony' },
      { rx: /zabieg/i, key: 'zabiegi' }
    ];
    function matchKey(txt) {
      for (var i = 0; i < keyByText.length; i++) if (keyByText[i].rx.test(txt)) return keyByText[i].key;
      return null;
    }
    document.querySelectorAll('.header__menu > ul > li').forEach(function (li) {
      var link = li.querySelector('a.menu__item, summary, a');
      if (!link) return;
      var key = matchKey(link.textContent || '');
      if (!key || !groups[key]) return;
      var g = groups[key];
      if (key === 'dermokosmetyki' ? !(g.brands || []).length : !(g.categories || []).length) return;
      li.classList.add('jad-has-mega');
      li.addEventListener('mouseenter', function () { openPanel(key); });
      li.addEventListener('mouseleave', function () { closePanel(); });
      link.addEventListener('focus', function () { openPanel(key); });
    });

    // ================= MOBILE / DRAWER =================
    var drawer = el('div', 'jad-drawer');
    var overlay = el('div', 'jad-drawer__overlay');
    var aside = el('aside', 'jad-drawer__panel');
    aside.setAttribute('role', 'dialog'); aside.setAttribute('aria-label', 'Menu');
    var top = el('div', 'jad-drawer__top');
    top.appendChild(el('span', 'jad-drawer__brand', 'Menu'));
    var closeBtn = el('button', 'jad-drawer__close', '×');
    closeBtn.setAttribute('aria-label', 'Zamknij');
    top.appendChild(closeBtn);
    var body = el('div', 'jad-drawer__body');
    aside.appendChild(top); aside.appendChild(body);
    drawer.appendChild(overlay); drawer.appendChild(aside);
    document.body.appendChild(drawer);

    // — widok glowny drawera —
    var homeView = el('div', 'jad-drawer__view');
    homeView.appendChild(el('div', 'jad-drawer__label', 'Najczęściej wybierane'));
    var favs = el('div', 'jad-drawer__favs');
    var zab = groups['zabiegi'];
    if (zab && zab.categories) zab.categories.slice(0, 4).forEach(function (c) { favs.appendChild(tile(c, 'jad-tile--sm')); });
    homeView.appendChild(favs);
    var wins = el('div', 'jad-drawer__windows');
    [
      { key: 'zabiegi', label: 'Zabiegi' },
      { key: 'dermokosmetyki', label: 'Dermokosmetyki' },
      { key: 'bony', label: 'Bony' },
      { key: 'o-nas', label: 'O nas' }
    ].forEach(function (w) {
      var g = groups[w.key] || {};
      var img = (g.categories && g.categories[0] && g.categories[0].image) || '';
      var t = tile({ title: w.label, url: g.url || (w.key === 'o-nas' ? '/pages/about-us' : '#'), image: img }, 'jad-tile--win');
      // Dermokosmetyki -> otwiera widok marek zamiast nawigacji
      if (w.key === 'dermokosmetyki' && (g.brands || []).length) {
        t.addEventListener('click', function (e) { e.preventDefault(); showBrandsView(); });
      }
      wins.appendChild(t);
    });
    homeView.appendChild(wins);
    body.appendChild(homeView);

    // — widok marek (dermokosmetyki) —
    var brandsView = el('div', 'jad-drawer__view jad-drawer__view--brands');
    brandsView.style.display = 'none';
    var back = el('button', 'jad-drawer__back', '← Menu');
    brandsView.appendChild(back);
    var dg = groups['dermokosmetyki'] || {};
    var mAllCosmo = el('a', 'jad-drawer__allcosmo');
    mAllCosmo.href = dg.allUrl || '/pages/dermokosmetyki';
    mAllCosmo.appendChild(el('b', null, 'Wszystkie kosmetyki'));
    mAllCosmo.appendChild(el('span', 'jad-drawer__allcosmo-arr', '→'));
    brandsView.appendChild(mAllCosmo);
    brandsView.appendChild(el('div', 'jad-drawer__label', 'Dermokosmetyki — obszary'));
    var mChips = el('div', 'jad-drawer__chips');
    var mList = el('div', 'jad-drawer__brands');
    var dBrands = dg.brands || [];
    (dg.areas || []).forEach(function (ar, i) {
      var c = el('span', 'jad-drawer__chip' + (i === 0 ? ' is-active' : ''), ar.label);
      c.addEventListener('click', function () {
        mChips.querySelectorAll('.jad-drawer__chip').forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
        mList.querySelectorAll('.jad-drawer__brand').forEach(function (row) {
          var a = row.getAttribute('data-areas') || '';
          row.style.display = (ar.key === 'wszystkie' || a.split(',').indexOf(ar.key) !== -1) ? '' : 'none';
        });
      });
      mChips.appendChild(c);
    });
    dBrands.forEach(function (br) {
      var a = el('a', 'jad-drawer__brand');
      a.href = br.url || '#';
      a.setAttribute('data-areas', br.areas || '');
      /* na dotyku nie ma hoveru — logo od razu w kolorze, inaczej marka jest nieczytelna */
      var badge = el('span', 'jad-drawer__brand-badge');
      var blogo = el('img', 'jad-drawer__brand-logo');
      blogo.src = LOGO_COLOR + br.handle + '.png';
      blogo.alt = ''; blogo.setAttribute('aria-hidden', 'true'); blogo.loading = 'lazy';
      blogo.addEventListener('error', function () {
        badge.classList.add('jad-drawer__brand-badge--initial');
        while (badge.firstChild) badge.removeChild(badge.firstChild);
        badge.textContent = br.initial || (br.name || '?').charAt(0);
      });
      badge.appendChild(blogo);
      a.appendChild(badge);
      a.appendChild(el('span', 'jad-drawer__brand-name', br.name || ''));
      a.appendChild(el('span', 'jad-drawer__brand-arrow', '→'));
      mList.appendChild(a);
    });
    brandsView.appendChild(mChips);
    brandsView.appendChild(mList);
    var allBtn = el('a', 'jad-drawer__allbrands', 'Wszystkie marki — dowiedz się więcej →');
    allBtn.href = dg.brandsUrl || '/pages/marki';
    brandsView.appendChild(allBtn);
    body.appendChild(brandsView);

    function showBrandsView() { homeView.style.display = 'none'; brandsView.style.display = 'block'; body.scrollTop = 0; }
    function showHomeView() { brandsView.style.display = 'none'; homeView.style.display = 'block'; }
    back.addEventListener('click', showHomeView);

    function openDrawer() { drawer.classList.add('is-open'); document.documentElement.classList.add('jad-noscroll'); showHomeView(); }
    function closeDrawer() { drawer.classList.remove('is-open'); document.documentElement.classList.remove('jad-noscroll'); }
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    if (!document.querySelector('.jad-drawer-trigger')) {
      var btn = el('button', 'jad-drawer-trigger');
      btn.setAttribute('aria-label', "Menu J'ADORE");
      btn.appendChild(el('span', 'jad-drawer-trigger__ico', '☰'));
      btn.appendChild(el('span', null, 'Menu'));
      btn.addEventListener('click', openDrawer);
      var host = document.querySelector('.menu-drawer-button') || document.querySelector('.header__icons--left') || document.querySelector('.header__wrapper');
      if (host && host.parentNode) host.parentNode.insertBefore(btn, host);
      else document.body.appendChild(btn);
    }
  });
})();
